import {assign, Machine} from "xstate"

export const toggleMachine = Machine({
    id: 'toggle',
    context: {
        initials: '',
        citizen: {},
        paymentrequest: '',
        rptpaymentrequest: '',
    },
    initial: 'inactive',
    states: {
        inactive: {
            on: {
                TOGGLE: 'active',
                INITIAL: {
                    actions: [
                        // (context) => console.log(`${context.initials}`),
                        "assignInitials",
                        // (context) => console.log(`${context.initials}`)
                    ]
                },
                CITIZEN: {
                    actions: [
                        // (context) => console.log(context.citizen),
                        "assignCitizen",
                        // (context) => console.log(context.citizen)
                    ]
                },
                PAYMENTREQUEST: {
                    actions: [
                        // (context) => console.log(context.paymentrequest),
                        "assignPaymentRequest",
                        // (context) => console.log(context.paymentrequest),
                    ]
                },
                RPTPAYMENTREQUEST: {
                    actions: [
                        "assignRPTPaymentRequest"
                    ]
                }
            }
        },
        active: {
            on: {
                TOGGLE: 'inactive',
            }
        }
    },
}, {
    actions: {
        assignCitizen: assign({
            citizen: (context, event) => event.citizen
        }),
        assignInitials: assign({
            initials: (context, event) => event.initials
        }),
        assignPaymentRequest: assign({
            paymentrequest: (context, event) => event.paymentrequest
        }),
        assignRPTPaymentRequest: assign({
            rptpaymentrequest: (context, event) => event.rptpaymentrequest
        })
    }
})